import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import appConfig from '../config/app-config';

@Injectable({
  providedIn: 'root',
})

export class LocationService {


  constructor(private http: HttpClient) {
  }

  getLocation(ipAddress: any): Observable<any> {
    return this.http.get(appConfig.myAccountBaseUrl + "location?ip=" + ipAddress);
  }

  getIpAddress(): Observable<any> {
    return this.http.get('https://api.ipify.org/?format=json');
  }
}
